// i18next-extract-mark-ns-start Step2
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import withNavigation from '../../hoc/withNavigation';
import { navigate } from '../../services/navigation';
import { colors, tabletThresholdPixels } from '../home/v4/styledComponents';
import { LineHorizontal } from './orderStyledComponents';
import routes from '../../Routes';
import leftArrow from '../../assets/chevron left.png';
import withOrderContext from '../../withOrderContext';

const StickyContainer = styled.div`
  ${({ isSticky }) => isSticky && `
  position: sticky;
  top: 88px;
  z-index: 2;`}
  width: 100%;
  background-color: ${colors.beige100};
  z-index: 2;
  margin-bottom: 64px;
  @media (max-width: ${tabletThresholdPixels}) {
    ${({ isSticky }) => isSticky && 'top: 50px;'}
    margin-bottom: 40px;
  }
`;

const ProgressBarContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  width: 50%;
  align-items: center;
  margin: 24px auto 12px;
  padding: 0 62px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 70%;
    padding: 0px;
  }
`;

const Progress = styled.div`
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  ${(props) => props.isActive && 'cursor: pointer'};
`;

const ProgressDot = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.isActive ? colors.black : colors.grey200};
  border: 1px solid ${colors.grey200};
  height: 20px;
  width: 20px;
  border-radius: 50%;
  margin-bottom: 4px;
  @media (max-width: ${tabletThresholdPixels}) {
    height: 15px;
    width: 15px;
  }
`;

const ProgressText = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${(props) => props.isActive ? colors.black : colors.grey200};
  position: absolute;
  top: 28px;
  width: 200px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 80px;
    font-size: 10px;
    top: 25px;
  }
`;

const Line = styled.div`
  position: relative;
  top: -3px;
  flex: 1;
  height: 3px;
  width: 100%;
  background-color:  ${(props) => props.isActive ? colors.black : colors.grey200};
  @media (max-width: ${tabletThresholdPixels}) {
    top: -2px;
  }
`;

const BackButton = styled.div`
  position: absolute;
  top: 20px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media (max-width: ${tabletThresholdPixels}) {
    left: -25px;
    top: 8px;
  }
`;

const BackImage = styled.img`
  position: absolute;
  font-weight: 500;
  width: auto;
  padding: 10px;
  margin: 0px;
  @media (max-width: ${tabletThresholdPixels}) {
    padding: 6px;
  }
`;

const getSteps = (t) => [
  { id: 1, name: t('Besoin'), url: routes.Step1Summary.url },
  { id: 2, name: t('Estimation'), url: routes.Step2.url },
  { id: 3, name: t('Confirmation'), url: routes.Step3.url },
];

const navigateToPreviousStep = (t, previousStepId, navigateToFirstStep) => {
  const steps = getSteps(t);
  const previousStep = previousStepId >= 1 ? steps[previousStepId - 1] : null;
  if (previousStepId === 1) {
    navigate(navigateToFirstStep());
  } else {
    navigate(previousStep.url);
  }
};

const renderBackButton = (t, currentStepId, navigateToFirstStep) => {
  if (currentStepId <= 1) return null;
  const previousStepId = currentStepId - 1;
  return (
    <BackButton onClick={() => navigateToPreviousStep(t, previousStepId, navigateToFirstStep)}>
      <BackImage back src={leftArrow} />
    </BackButton>
  );
};

function ProgressBar({ step, orderContext: { navigateToFirstStep } }) {
  const { t } = useTranslation();
  const steps = getSteps(t);
  return (
    <StickyContainer isSticky={step === 1}>
      <ProgressBarContainer>
        {renderBackButton(t, step, navigateToFirstStep)}
        {steps.map((stepIt, index) => {
          const stepId = stepIt.id;
          const isActive = step >= stepId;
          return (
            <React.Fragment key={stepId}>
              <Progress isActive={isActive} onClick={() => isActive && navigateToPreviousStep(t, stepId, navigateToFirstStep)}>
                <ProgressDot isActive={isActive} />
                <ProgressText isActive={isActive}>{stepIt.name}</ProgressText>
              </Progress>
              {index + 1 !== steps.length && <Line isActive={step >= stepId + 1} />}
            </React.Fragment>
          );
        })}
      </ProgressBarContainer>
      <LineHorizontal />
    </StickyContainer>
  );
}

ProgressBar.propTypes = {
  step: PropTypes.number.isRequired,
  orderContext: PropTypes.shape({
    navigateToFirstStep: PropTypes.func.isRequired,
  }).isRequired,
};

export default withNavigation(
  withOrderContext(ProgressBar),
);
